import React from 'react';
import { ThemeProvider as Emotion } from 'emotion-theming';
import {
  ThemeProvider as Material,
  StylesProvider,
} from '@material-ui/core/styles';

import { theme } from './theme';

export const ThemeProvider: React.FC = props => {
  const { children } = props;

  return (
    <Emotion theme={theme}>
      <StylesProvider injectFirst>
        <Material theme={theme}>{children}</Material>
      </StylesProvider>
    </Emotion>
  );
};

export const PureThemeProvider: React.FC = props => (
  <Material theme={theme}>{props.children}</Material>
);
